import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import OrgsContext from "../../../contexts/OrgsContext";
import { BestSelect } from "best-common-react";
import SelectedTeamContext from "../../../contexts/SelectedTeamContext";
import MLBPlayerSummaryContext from "../../../contexts/MLBPlayerSummaryContext";

const FiltersContainer = styled.div.attrs(() => ({
  className: "d-flex justify-content-start"
}))`
  flex-direction: row;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const Filter = styled.div.attrs(() => ({
  className: "col-xs col-md-3 pl-0"
}))`
  @media (max-width: 767px) {
    margin-bottom: 0.75rem;
  }
`;

const MLBPlayerDetailsHeader = () => {
  const { orgs } = useContext(OrgsContext).state;
  const { teams } = useContext(SelectedTeamContext).state;
  const {
    playerStatuses,
    orgFilter,
    fedFilter,
    statusSelected,
    setOrgFilter,
    setFedFilter,
    setStatusSelected
  } = useContext(MLBPlayerSummaryContext);

  const allOrgs = { value: null, label: "All Organizations" };
  const allFeds = { value: null, label: "All Federations" };
  const allStatuses = { label: "All Club Request Statuses", value: "all" };
  const statusOptions = [allStatuses, ...playerStatuses];

  const federationOptions =
    teams?.length > 0 ? [allFeds, ...teams.map(team => ({ value: team?.value, label: team?.label }))] : [allFeds];
  const orgOptions =
    orgs?.length > 0
      ? [
          allOrgs,
          ...orgs
            .filter(org => !["BOC", "MSB", "NONE"].includes(org.orgCode.toUpperCase()))
            .map(org => ({ value: org?.orgId, label: org?.orgName }))
        ]
      : [allOrgs];

  return (
    <div className="form-group">
      <FiltersContainer>
        <Filter>
          {
            <BestSelect
              name="orgsDropdown"
              value={orgFilter ? orgOptions.find(org => org.value == orgFilter) : allOrgs}
              options={orgOptions}
              onChange={org => {
                setOrgFilter(org.value);
              }}
            />
          }
        </Filter>
        <Filter>
          {
            <BestSelect
              name="federationsDropdown"
              value={fedFilter ? federationOptions.find(fed => fed.value == fedFilter) : allFeds}
              options={federationOptions}
              onChange={fed => {
                setFedFilter(fed.value);
              }}
            />
          }
        </Filter>
        <Filter>
          {
            <BestSelect
              name="requestStatusDropdown"
              value={statusSelected}
              options={statusOptions}
              onChange={status => {
                setStatusSelected(status);
              }}
            />
          }
        </Filter>
      </FiltersContainer>
    </div>
  );
};

export default MLBPlayerDetailsHeader;
